<template>
  <div id="nav">
    <router-link :to="{ name: 'home'}" class="box">Home</router-link>
    <router-link :to="{ name: 'schedule'}" class="box">Schedule</router-link>
    <router-link :to="{ name: 'footballHome'}" class="box">Football</router-link>
    <router-link :to="{ name: 'cricketHome'}" class="box">Cricket</router-link>
    <router-link v-if="kabaddiSeasonKey" :to="{ name: 'kabaddiSeason', params: {key: kabaddiSeasonKey}}" class="box">Kabaddi 2019</router-link>
    <router-link :to="{ name: 'MetricHome'}" class="box">Metric 101</router-link>
    <router-link :to="{ name: 'FGHome'}" class="box">Fantasy Game</router-link>
    <router-link :to="{ name: 'FCHome'}" class="box">Fantasy Console</router-link>
  </div>
</template>
<script>

import { FootballTournament } from '@/models/tournament'
import Config from '@/config'

export default {
  data () {
    return {
      kabaddiSeasonKey: Config.kabaddiSeasonKey
    }
  },
  mounted () {
    FootballTournament.recent().then(tournaments => {
      this.tournaments = tournaments
    }).catch((error) => {
      console.error(error)
    })
  }
}
</script>
